/** Max tags when graph tag mode is Individual Tags (enforced in UI and on Generate). */
export const MAX_INDIVIDUAL_TAGS = 5;
